function renderTrendOverviewSection() {
    function renderTrendCard(trendData) {
        function renderTrendFooterArrow() {
            const arrowElement = document.createElementNS(
                'http://www.w3.org/2000/svg',
                'svg'
            );
            arrowElement.setAttribute('viewBox', '0 0 32 32');
            arrowElement.setAttribute('fill', 'none');

            const path = document.createElementNS(
                'http://www.w3.org/2000/svg',
                'path'
            );
            path.setAttribute(
                'd',
                'M18.0657 23L17.399 22.3137L23.199 16.4804L6.99902 16.4804V15.5196L23.199 15.5196L17.399 9.68627L18.0657 9L24.999 16L18.0657 23Z'
            );
            path.setAttribute('fill', 'white');
            arrowElement.appendChild(path);
            return arrowElement;
        }

        const cardElement = document.createElement('div');
        cardElement.classList.add('all-trends-card');
        // Render bg img
        const bgImgElement = document.createElement('img');
        bgImgElement.src = trendData.imgSrc;
        bgImgElement.alt = trendData.title;
        bgImgElement.classList.add('bg-img');
        cardElement.appendChild(bgImgElement);
        // Render Overlay
        const overlayElement = document.createElement('div');
        overlayElement.classList.add('all-trends-overlay');
        const overlayImgElement = document.createElement('img');
        overlayImgElement.src = trendData.illustrationSrc;
        overlayImgElement.alt = trendData.title;
        overlayElement.appendChild(overlayImgElement);
        cardElement.appendChild(overlayElement);
        // Render Vision Badge
        const badgeElement = document.createElement('span');
        badgeElement.classList.add('vision-badge');
        badgeElement.classList.add('vision-badge-sm');
        badgeElement.setAttribute('data-category', trendData.categoryId);
        badgeElement.textContent = trendData.category;
        cardElement.appendChild(badgeElement);
        // Render Footer
        const footerElement = document.createElement('div');
        footerElement.classList.add('all-trends-footer');
        const footerTitleElement = document.createElement('span');
        footerTitleElement.innerText = trendData.title;
        footerElement.appendChild(footerTitleElement);
        footerElement.appendChild(renderTrendFooterArrow());
        cardElement.appendChild(footerElement);

        // Handle link click
        function handleLink() {
            window.location.href = trendData.url;
        }

        cardElement.addEventListener('click', handleLink);
        cardElement.addEventListener('keypress', handleLink);
        return cardElement;
    }

    function renderSectionItems(trendData) {
        const trendItemsElement = document.createElement('div');
        trendItemsElement.classList.add('all-trends-items');
        trendData.items.forEach((item) => {
            trendItemsElement.appendChild(renderTrendCard(item));
        });
        trendItemsElement.setAttribute('id', `trendSection-${trendData.category}`);
        return trendItemsElement;
    }

    function renderSectionHeader(trendData) {
        function getHeadings(trendData) {
            const m = /^(.*)\s(\w+)$/.exec(trendData.title);
            if (m !== null) {
                return {subtitle: m[1], title: m[2]};
            }
            return {subtitle: '', title: trendData.title};
        }

        function renderArrowIcon() {
            const arrowIcon = document.createElementNS(
                'http://www.w3.org/2000/svg',
                'svg'
            );
            arrowIcon.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
            arrowIcon.setAttribute('viewBox', '0 0 40 40');
            arrowIcon.classList.add('all-trends-accordion-arrow');
            const arrowPath = document.createElementNS(
                'http://www.w3.org/2000/svg',
                'path'
            );
            arrowPath.setAttribute(
                'd',
                'M30 14.5918L20 25L10 14.5918L10.9804 13.5714L20 22.9592L29.0196 13.5714L30 14.5918Z'
            );
            arrowPath.setAttribute('fill', 'black');
            arrowIcon.appendChild(arrowPath);
            return arrowIcon;
        }

        // Header container
        const sectionHeaderElement = document.createElement('div');
        sectionHeaderElement.classList.add('all-trends-section-header');
        // Heading
        const headingElement = document.createElement('h2');
        headingElement.classList.add('all-trends-row-heading');
        const {subtitle, title} = getHeadings(trendData);
        const subtitleElement = document.createElement('span');
        subtitleElement.classList.add('all-trends-row-heading-subtitle');
        subtitleElement.textContent = subtitle;
        const titleElement = document.createElement('span');
        titleElement.textContent = title;
        headingElement.appendChild(subtitleElement);
        headingElement.appendChild(titleElement);
        sectionHeaderElement.appendChild(headingElement);
        // Icon
        sectionHeaderElement.appendChild(renderArrowIcon());
        // Add event listener (collapse / expand)
        function toggle() {
            const sectionElement = sectionHeaderElement;
            const itemsElement = sectionElement.nextElementSibling;
            if (sectionElement.classList.contains('open')) {
                sectionElement.classList.remove('open');
                itemsElement.style.maxHeight = null;
                sectionHeaderElement.setAttribute('aria-expanded', 'true');
            } else {
                sectionElement.classList.add('open');
                itemsElement.style.maxHeight = '100%';
                sectionHeaderElement.setAttribute('aria-expanded', 'false');
            }
        }
        sectionHeaderElement.addEventListener('click', toggle);
        sectionHeaderElement.addEventListener('keypress', toggle);
        // A11y
        sectionHeaderElement.setAttribute('role', 'button');
        sectionHeaderElement.setAttribute('aria-expanded', 'false');
        sectionHeaderElement.setAttribute('aria-controls', `trendSection-${trendData.category}`);
        return sectionHeaderElement;
    }

    const container = document.getElementById('all-trends-container');

    if (container) {
        const trendData = container.getAttribute('data-trends');
        const categoryData = {};
       JSON.parse(trendData).forEach((trendItem) => {
          if(categoryData[trendItem['categoryId']]) {
             categoryData[trendItem['categoryId']].push(trendItem);
          } else {
             categoryData[trendItem['categoryId']] = [trendItem];
          }
       });
        const parsedTrendData = Object.keys(categoryData).map((categoryId) => {
            return {
                title: categoryData[categoryId][0].category,
                category: categoryId,
                items: categoryData[categoryId],
            };
        });

        parsedTrendData.forEach((trend) => {
            container.appendChild(renderSectionHeader(trend));
            container.appendChild(renderSectionItems(trend));
        });
    }
}

renderTrendOverviewSection();
